// Workspace activo (M7, equipos): si el usuario trabaja sobre el espacio de
// otro (Business), se persiste aquí y el cliente tRPC lo envía en la cabecera
// x-workspace-owner. El backend solo lo aplica a los routers de datos.

const KEY = 'suscri-workspace';

export type ActiveWorkspace = {
  ownerId: string;
  ownerName: string;
  role: string;
};

export function getActiveWorkspace(): ActiveWorkspace | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ActiveWorkspace;
    return parsed.ownerId ? parsed : null;
  } catch {
    return null;
  }
}

export function setActiveWorkspace(ws: ActiveWorkspace | null): void {
  try {
    if (ws) localStorage.setItem(KEY, JSON.stringify(ws));
    else localStorage.removeItem(KEY);
  } catch {
    /* localStorage no disponible */
  }
  // Recarga completa: garantiza que todas las queries se rehacen con la
  // cabecera nueva y no queda caché del espacio anterior.
  window.location.reload();
}
